"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _cmsDesignComponent = require("@tencent/cms-design-component");
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatFreeWithCredit = (properties, options = {}) => {
  try {
    const modTitle = properties.modTitle,
      description = properties.description,
      color = properties.color,
      _properties$list = properties.list,
      list = _properties$list === void 0 ? [] : _properties$list;
    const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
        domains: options === null || options === void 0 ? void 0 : options.domains
      }),
      formatUrlString = _getFormatUrlMethods.formatUrlString,
      formatUrlInText = _getFormatUrlMethods.formatUrlInText;
    const lists = [];
    for (let i = 0; i < list.length; i++) {
      const richBtnTxt = [];
      const _list$i = list[i],
        txt = _list$i.txt,
        type = _list$i.type,
        hrefBase = _list$i.href,
        modalTitle = _list$i.modalTitle,
        richTextContent = _list$i.richTextContent,
        popConfirm = _list$i.popConfirm,
        popConfirmHrefBase = _list$i.popConfirmHref,
        popCancel = _list$i.popCancel,
        popCancelHrefBase = _list$i.popCancelHref;
      const href = formatUrlString(hrefBase);
      const popConfirmHref = formatUrlString(popConfirmHrefBase);
      const popCancelHref = formatUrlString(popCancelHrefBase);
      popCancel && richBtnTxt.push({
        type: 'cancel',
        txt: popCancel,
        href: popCancelHref
      });
      popConfirm && richBtnTxt.push({
        type: 'confirm',
        txt: popConfirm,
        href: popConfirmHref
      });
      const itemData = {
        txt,
        type,
        href,
        modalTitle,
        richTextContent: formatUrlInText(richTextContent),
        richBtnTxt,
        extendProps: {
          'report-event': type === 'a' ? 'click_freeWithCredit_a_href' : 'click_freeWithCredit_pop_href',
          'report-ext1': i,
          'report-ext2': txt,
          'report-ext3': href || ''
        }
      };
      lists.push(itemData);
    }
    const configuration = {
      description,
      list: lists
    };
    return {
      modTitle,
      configuration,
      bgColor: color
    };
  } catch (error) {
    return {
      modTitle: '',
      configuration: {},
      bgColor: ''
    };
  }
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatFreeWithCredit = formatFreeWithCredit(data, {
        domains
      }),
      modTitle = _formatFreeWithCredit.modTitle,
      configuration = _formatFreeWithCredit.configuration,
      bgColor = _formatFreeWithCredit.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_freeWithCredit', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.FreeWithCredit, {
      flexTitle: modTitle,
      configuration: configuration,
      style: bgStyle
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}